import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const Filter = (props) => (<Svg viewBox="0 0 20 18" {...props}>
    <Path d="M18.333 1.5H1.667l6.666 7.883v5.45l3.334 1.667V9.383L18.333 1.5Z" stroke="#393360" strokeWidth={1.667} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default Filter;
